var map = {
	"app/modules/company-operator/company-operator.module": [
		"./src/app/modules/company-operator/company-operator.module.ts",
		"common",
		"company-operator.module"
	],
	"app/modules/company-user/company-user.module": [
		"./src/app/modules/company-user/company-user.module.ts",
		"common",
		"company-user.module"
	],
	"app/modules/company/company.module": [
		"./src/app/modules/company/company.module.ts",
		"common",
		"company.module"
	],
	"app/modules/factory/factory.module": [
		"./src/app/modules/factory/factory.module.ts",
		"common",
		"factory.module"
	],
	"app/modules/manufacturer/manufacturer.module": [
		"./src/app/modules/manufacturer/manufacturer.module.ts",
		"common",
		"manufacturer.module"
	],
	"app/modules/page/page.module": [
		"./src/app/modules/page/page.module.ts",
		"common",
		"page.module"
	],
	"app/modules/product/product.module": [
		"./src/app/modules/product/product.module.ts",
		"common",
		"product.module"
	],
	"app/modules/profile/profile.module": [
		"./src/app/modules/profile/profile.module.ts",
		"common",
		"profile.module"
	],
	"app/modules/report/report.module": [
		"./src/app/modules/report/report.module.ts",
		"common",
		"report.module"
	],
	"app/modules/stamp-batch-order/stamp-batch-order.module": [
		"./src/app/modules/stamp-batch-order/stamp-batch-order.module.ts",
		"common",
		"stamp-batch-order.module"
	],
	"app/modules/stamp-list/stamp-list.module": [
		"./src/app/modules/stamp-list/stamp-list.module.ts",
		"common",
		"stamp-list.module"
	],
	"app/modules/stamplot-list/stamplot-list.module": [
		"./src/app/modules/stamplot-list/stamplot-list.module.ts",
		"common",
		"stamplot-list.module"
	],
	"app/modules/stamplot/stamplot.module": [
		"./src/app/modules/stamplot/stamplot.module.ts",
		"common",
		"stamplot.module"
	],
	"app/modules/stamprevocation/stamprevocation.module": [
		"./src/app/modules/stamprevocation/stamprevocation.module.ts",
		"common",
		"stamprevocation.module"
	],
	"app/modules/stamps/stamp.module": [
		"./src/app/modules/stamps/stamp.module.ts",
		"common",
		"stamp.module"
	],
	"app/modules/verification-report/verification-report.module": [
		"./src/app/modules/verification-report/verification-report.module.ts",
		"common",
		"verification-report.module"
	],
	"app/modules/warranty/warranty.module": [
		"./src/app/modules/warranty/warranty.module.ts",
		"common",
		"warranty.module"
	],
	"app/pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"home.module"
	],
	"app/pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"common",
		"login.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main